import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import PreviewFabricButton from '../_components/PreviewFabricButton';
import { OnTogglePreviewFabric } from '../_actions/ToolsActions';
import { OnViewerResize } from '../../Viewer/_actions/ViewerActions';

const mapStateToProps = (store:Immutable.Record<any>, props:Props) => ({
	windowWidth: store.getIn(['create', 'window', 'width']),
	viewerHeight: store.getIn(['create', 'viewer', 'height']),
	previewFabricEnabled: store.getIn(['create', 'tools','previewFabric','enabled']),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	onTogglePreviewFabric: () => dispatch(OnTogglePreviewFabric()),
	resizeViewer: (width: number, height: number) => dispatch(OnViewerResize(width, height)),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(PreviewFabricButton);